<template lang="pug">
div
  el-row
    el-col(:span="24")
      app-resumo-cadastrante-areas-patrimoniais(:cadastrante="cadastro.cadastrante", :idCadastro="idCadastro")

      app-divider(label="Interessado")
      div.pad5
        p
          span.label CNPJ:
          span &nbsp {{ cadastro.interessado.pessoa.pessoaJuridica.cnpj }}
        p
          span.label {{ labelsCadastro.interessado.prefeitura }}
          span &nbsp {{ cadastro.interessado.pessoa.pessoaJuridica.razaoSocial }}
        p
          span.label {{ labelsCadastro.interessado.cpfPrefeito }}
          span &nbsp {{ cadastro.interessado.prefeito.pessoaFisica.cpf }}
        p
          span.label {{ labelsCadastro.interessado.nomePrefeito }}
          span &nbsp {{ cadastro.interessado.prefeito.pessoaFisica.nome }}
        p
          app-resumo-endereco(:endereco="cadastro.interessado.pessoa.endereco")
        p
          app-resumo-documentos(:documentos="cadastro.interessado.documentos", :idCadastro="idCadastro", codigoCadastro="interessado")
      app-resumo-geo.pad5(:geo="cadastro.georreferenciamento", :idCadastro="idCadastro")
</template>
<script>
import { mapActions } from 'vuex'
import AppResumoCadastranteAreasPatrimoniais from '@/components/resumo/AppResumoCadastranteAreasPatrimoniais'
import AppResumoInteressado from '@/components/resumo/AppResumoInteressado'
import AppResumoGeo from '@/components/resumo/AppResumoGeo.vue'
import AppResumoDocumentos from '@/components/resumo/AppResumoDocumentos'
import AppResumoEndereco from '@/components/resumo/AppResumoEndereco'
import AppDivider from '@/components/AppDivider'
const {labelsCadastro} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {
  components: {
    AppResumoCadastranteAreasPatrimoniais,
    AppResumoInteressado,
    AppResumoGeo,
    AppResumoDocumentos,
    AppResumoEndereco,
    AppDivider
  },

  data () {
    return {labelsCadastro}
  },

  props: ['cadastro', 'idCadastro'],

  methods: {
    ...mapActions({
      findCadastro: 'cadastro/findByIdCadastro'
    })

  }
}
</script>
<style lang="scss" scoped>
.label {
  font-weight: bold;
}
.pad5 {
  padding: 25px 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/areasPatrimoniais/components/Resumo.vue